import { createContext, Dispatch, SetStateAction } from "react";
import { Common } from "../../../../common/src";
import { Viewer } from "../../../viewer/viewer";

/*****************************************
  export displayType/interface/const
******************************************/
export interface IEnabledUpdateProjectDetail {
  name?: string;
  helmert_transformation?: number;
  coordinate_transformation?: number;
  point_splitting_lidar?: number;
  point_splitting_sfm?: number;
  point_splitting_helmert?: number;
  remove_lidar?: number;
  remove_sfm?: number;
  remove_helmert?: number;
  point_txt_lidar?: number;
  point_txt_sfm?: number;
  point_txt_helmert?: number;
  ifc_file?: string;
  ply_file?: string;
  las_file?: string;
  design_file?: string;
  dxf_file?: string;
  gsx_file?: string;
  isArView? :string;
  isIosView? :string;
}

export enum EFileType {
  LAS = "LAS",
  PLY = "PLY",
  TXT = "TXT",
}

export enum EDisplayType {
  Web = "Web",
  iOS = "iOS",
  AR = "WebAR",
}

export enum LoadingStatus {
  Loading = "Loading",
  Loaded = "Loaded",
  Error = "Error",
}

export enum resErrCode {
  Authority = 403,
  NotFound = 404,
}

export enum EViewerMode {
  DEFAULT = "DEFAULT",
  CALCULATION = "CALCULATION",
  HELMERT_TRANSFORM = "HELMART_TRANSFORM",
  POINT_REMOVE = "POINT_REMOVE",
  PHOTO = "PHOTO",
  EXPORT_TO_OTHER = "EXPORT_TO_OTHER",
  IFC_PLACEMENT = "IFC_PLACEMENT"
}

export enum EUpdateStatus {
  SAVED = "saved",
  SAVE_FAILED_FORBIDDEN = "save failed - forbidden",
  SAVE_FAILED_ERROR = "save failed - server error",
  SAVE_FAILED = "save failed",
}

export enum EDialogType {
  NONE = "NONE",
  REGISTER_WITH_DASHBOARD = "REGISTER_WITH_DASHBOARD",
  REGISTER_WITH_LLV = "REGISTER_WITH_LLV",
  EXPORT_DATA = "EXPORT_DATA",
  PROJECT_DETAIL = "PROJECT_DETAIL",
  POINT_REMOVE = "POINT_REMOVE",
  REGISTER_WITH_POINTWORKS = "REGISTER_WITH_POINTWORKS",
  PROCESS_COMPLETED = "PROCESS_COMPLETED",
  SETTING = "SETTING",
  PROJECT_DELETE = "PROJECT_DELETE",
  DELETE_ALL_POINTS = "DELETE_ALL_POINTS",
}

export enum DETAIL_TAB {
  SIMPLE = "SIMPLE",
  SFM = "SFM",
  HELMERT = "HELMERT",
  PHOTO = "PHOTO",
  AR = "AR",
}

export const DETAIL_TAB2POINT_CLOUD_TYPE = (tab: DETAIL_TAB) => {
  switch (tab) {
    case DETAIL_TAB.SIMPLE:
      return Common.POINT_CLOUD_TYPE.SIMPLE;
    case DETAIL_TAB.SFM:
      return Common.POINT_CLOUD_TYPE.SFM;
    case DETAIL_TAB.HELMERT:
      return Common.POINT_CLOUD_TYPE.HELMERT;
    case DETAIL_TAB.AR:
      return Common.POINT_CLOUD_TYPE.AR;
    default:
      return Common.POINT_CLOUD_TYPE.UNKNOWN;
  }
};

export const POINT_CLOUD_TYPE2DETAIL_TAB = (type: Common.POINT_CLOUD_TYPE) => {
  switch (type) {
    case Common.POINT_CLOUD_TYPE.SIMPLE:
      return DETAIL_TAB.SIMPLE;
    case Common.POINT_CLOUD_TYPE.SFM:
      return DETAIL_TAB.SFM;
    case Common.POINT_CLOUD_TYPE.HELMERT:
      return DETAIL_TAB.HELMERT;
    default:
      return;
  }
};

export type TProjectDetailContext = {
  displayType: EDisplayType;
  getProjectDetail: (sholdSetProcessIds?: boolean) => void;
  userSettings: Common.userSetting;
  updateProjectDetail: (newDetail: IEnabledUpdateProjectDetail) => void;
  projectDetail: Common.ProjectDetail;
  viewer: Viewer;
  currentPointCloud: Common.POINT_CLOUD_TYPE;
  updateCurrentPointCloud: (newType: Common.POINT_CLOUD_TYPE) => void;
  currentViewerMode: EViewerMode;
  updateCurrentViewerMode: (newMode: EViewerMode) => void;
  whilePointCloudLoading: boolean;
  updateWhilePointCloudLoading: (val: boolean) => void;
  isJapanese: boolean;
  isDialogType: EDialogType;
  updateCurrentDialog: (v: EDialogType) => void;
  detailTab?: DETAIL_TAB | null;
  setDetailTab?: Dispatch<SetStateAction<DETAIL_TAB | null>>;
  openProjectState: boolean;
  setOpenProjectState: Dispatch<SetStateAction<boolean>>;
  reloadPointCloud: () => void;
  isArView: boolean;
  isIosView: boolean;
  showGsplat: boolean;
  setShowGsplat: Dispatch<SetStateAction<boolean>>;
  showIfcPutObject?: boolean;
  setShowIfcPutObject?: Dispatch<SetStateAction<boolean>>;
  selectedIfcObjectId?: string | null;
  setSelectedIfcObjectId?: Dispatch<SetStateAction<string | null>>;
  selectedIfcObjectUrl?: string | null;
  setSelectedIfcObjectUrl?: Dispatch<SetStateAction<string | null>>;
  selectedIfcObjectName?: string | null;
  setSelectedIfcObjectName?: Dispatch<SetStateAction<string | null>>;
};

export type TUseSnackbarContext = {
  openSuccess: (msg: string) => void;
  onCloseSuccess: () => void;
  openWarning: (msg: string) => void;
  onCloseWarning: () => void;
  openError: (msg: string) => void;
  onCloseError: () => void;
};

// context
export const ProjectDetailContext = createContext<TProjectDetailContext>({
  projectDetail: null,
} as TProjectDetailContext);

export const UseSnackbarContext = createContext<TUseSnackbarContext>({
  openSuccess: (msg: string) => {},
  onCloseSuccess: () => {},
  openWarning: (msg: string) => {},
  onCloseWarning: () => {},
  openError: (msg: string) => {},
  onCloseError: () => {},
});

export enum RESULT {
  SUCCESS = "success",
  ERROR = "error",
}

export enum PROCESS {
  HELMERT = "helmert",
  POINT_REMOVAL = "point removal",
  TRANSFORMATION = "transformation",
}

export interface ProcessResult {
  id: string;
  process: PROCESS;
  result: RESULT;
}

export interface GAObj {
  jobsiteId: string;
  userId: string;
  corporationId: string;
}

export interface ProcessIds {
  sfm: string;
  helmert: string;
  ar: string;
}

export interface PollingIds {
  sfm: number;
  helmert: number;
  ar: number;
}

interface IPollingContext {
  processIds: ProcessIds;
  updateProcessIds: (processIds: ProcessIds) => void;
  callback: () => void;
  setCallback: Dispatch<SetStateAction<() => void>>;
}

export const PollingContext = createContext<IPollingContext>(
  {} as IPollingContext
);
